import request from '@/utils/request'

const tradeSellContractKeypointApi = {
  trade_sell_contract_keypoint_list: '/trade/sell_contract_keypoint/',
  trade_sell_contract_keypoint_create: '/trade/sell_contract_keypoint/',
  trade_sell_contract_keypoint_update: '/trade/sell_contract_keypoint/',
  trade_sell_contract_keypoint_delete: '/trade/sell_contract_keypoint/'
}

/**
 * 列表
 */
export function sell_contract_keypoint_list (parameter) {
  return request({
    url: tradeSellContractKeypointApi.trade_sell_contract_keypoint_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function sell_contract_keypoint_create (parameter) {
  return request({
    url: tradeSellContractKeypointApi.trade_sell_contract_keypoint_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function sell_contract_keypoint_update (parameter, sell_contract_keypoint_id) {
  return request({
    url: tradeSellContractKeypointApi.trade_sell_contract_keypoint_update + sell_contract_keypoint_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function sell_contract_keypoint_delete (sell_contract_keypoint_id) {
  return request({
    url: tradeSellContractKeypointApi.trade_sell_contract_keypoint_delete + sell_contract_keypoint_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
